<template>
    <div class="twoColumnImageText">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-row :gutter="20">
                <el-col :span="12" v-for="(item,index) in newList2" :key="index">
                    <div class="newList2">
                        <div class="newListImg">
                            <img :src="item.imgUrl" :alt="item.imgAlt">
                        </div>
                        <p class="title">
                            <span>{{item.title}}</span>
                        </p>
                        <p class="newText" v-if="item.summary">{{item.summary}}</p>
                        <!-- <el-button size="small" plain>→ 点击进入</el-button> -->
                        <div>
                            <el-button size="small" plain  @click="handleClick(i)"  v-for="(i, index2) in item.data.buttons" :key="index2">→ {{i.text}}</el-button>
                        </div>
                        <div class="WX" v-if="item.data.qrcodeUrl">
                            <img :src="item.data.qrcodeUrl" :alt="item.imgAlt">
                            <p>{{item.data.qrcodeText}}</p>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    val: {}
  },
    data(){
        return{
            newList2:[],
        }
    },
    created() {
      this.newList2 = this.val.attaches;
    },
    methods: {
      handleClick(row) {
        window.open(row.linkUrl, '_self');
      }
    }
}
</script>
<style lang="less" scoped>
.twoColumnImageText{
    .newList2{
        border-radius: 4px;
        background: #f7f7f7;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        margin-bottom: 10px;
        padding-bottom: 20px;
        position: relative;
        min-height: auto;
        .newListImg{
            overflow: hidden;
            height: 125px;
            img{
                height: 100%;
                width: 100%;
                display: block;
            }
        }
        .newListImg{
            img:hover{
                transform: scale(1.2);
                transition: all 3s;
            }
        }
        p.title{
            padding: 15px 10px;
            line-height: 18px;
            margin: 0;
            overflow: hidden; /*隐藏*/
            white-space: nowrap;  /*不换行*/
            text-overflow: ellipsis;  /* 超出部分省略号 */
            width: 100%;
            box-sizing: border-box;
            span{
                color: #d11a2e;
                font-size: 16px;
            }
        }
        p.newText{
            text-align:left;
            font-size: 14px;
            line-height: 28px;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            margin: 0 10px 10px;
            padding: 0;
            height: 56px;
            overflow: hidden;
        }
        .el-button{
            margin-top:8px;
        }
        .el-button:hover{
            border:1px solid #d11a2e;
            color: #d11a2e;
        }
        .el-button:focus{
            color: #d11a2e;
            border-color: #d11a2e;
            background-color: #f7f7f7;
        }
        .WX{
            display: none;
            position: absolute;
            right:10px;
            bottom: 10px;
            // display: inline-block;
            // display: flex;
            vertical-align: middle;
            text-align: center;
            font-size: 14px;
            img{
                width: 65px;
                margin: 0 auto;
            }
            p{
                margin: 0;
            }
        }
    }
    @media (min-width: 768px){
        .newList2{
            .WX{
                display: inline-block;
            }
        }

    }
    @media (min-width: 768px) and (max-width: 1024px) {
        .newList2{
            min-height: 410px;
            p.title {
                span{
                    font-size: 16px;
                }
                .dateText{
                    font-size: 14px;
                    width: auto;
                    float: right;
                }
            }
            .newListImg{
                height: 215px;
            }

        }

    }
    @media (min-width: 1025px) and (max-width: 1200px) {
        .newList2{
            min-height: 430px;
            p.title {
                span{
                    font-size: 16px;
                }
                .dateText{
                    font-size: 14px;
                    float: right;
                    width: auto;
                }
            }
            .newListImg{
                height: 235px;
            }
        }
    }
    @media only screen and (min-width: 1200px){
        .newList2{
            min-height: 450px;
            p.title {
                span{
                    font-size: 16px;
                }
                .dateText{
                    font-size: 14px;
                    float: right;
                    width: auto;
                }
            }
            .newListImg{
                height: 265px;
            }
        }
    }


}
</style>



// WEBPACK FOOTER //
// src/components/item/patch16.vue